module.exports = __webpack_public_path__ + "img/hcn-logo.f7569790.png";